import Back from '../assets/back.svg?react'

interface IBackButtonProps {
    onClick: () => void
}

export const BackButton = (props: IBackButtonProps) => {
    return (
        <div className={'flex items-center gap-x-2 cursor-pointer'} onClick={props.onClick}>
            <Back width={18} height={18}/>
            <div className={'text-xl'}>Back</div>
        </div>
    )
}